// extracted by mini-css-extract-plugin
export default {"category_item_container":"UserCategories_category_item_container__t4UNB","edit_category_container":"UserCategories_edit_category_container__KuQjr"};